'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = setGlobal;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function setGlobal(globalToMutate, key, value) {
  // @ts-expect-error: no index
  globalToMutate[key] = value;
}
